module.exports = __webpack_public_path__ + "img/dis-zichantubiao.78120ff1.svg";